import React from 'react';
import {connect} from 'react-redux'
import { withRouter } from 'react-router-dom'
import SyntaxHighlighter  from 'react-syntax-highlighter';
import { atelierEstuaryLight } from 'react-syntax-highlighter/dist/styles/hljs';
import widgetExample from './widget'
import _ from 'lodash'



class WidgetCodeSnippet extends React.Component {
    constructor(){
        super();
    }   

    render() {
        return (
            <div>
                <SyntaxHighlighter style={atelierEstuaryLight}>
                {widgetExample(this.props.currentOrganization.id)}
                </SyntaxHighlighter>
                <a href={`https://minnow.nextinline.io/?organizationID=${this.props.currentOrganization.id}`}>
                    Example 
                </a>
            </div>
        );
    }
}
export default withRouter(connect((state)=>state)(WidgetCodeSnippet))



// WEBPACK FOOTER //
// ./src/components/partials/WidgetCodeSnippet/index.jsx